import { createApp } from 'vue/dist/vue.esm-bundler';
import EventsFilter from './components/EventsFilter';
import EventsList from './components/EventsList';
import EventsInfo from './components/EventsInfo';
import VueDatePicker from '@vuepic/vue-datepicker';
import './assets/scss/app.scss';
import '@vuepic/vue-datepicker/dist/main.css'
import ClickOutside from './utils/clickOutside';

const vueApp = createApp({
    delimiters: ['[[', ']]'],
    comments: true,
    data() {
        return {
            selectedYear: undefined,
            selectedType: undefined
        };
    },
    methods: {
        updateYear(value) {
            this.selectedYear = value;
            this.selectedType = undefined;
        },
        updateType(value) {
            this.selectedType = value;
        }
    },
    mounted() {
    }
});

vueApp.directive('click-outside', ClickOutside);
vueApp.component('EventsFilter', EventsFilter);
vueApp.component('EventsList', EventsList);
vueApp.component('EventsInfo', EventsInfo);
vueApp.component('VueDatePicker', VueDatePicker);

const instance = vueApp.mount("#appEvents");

export { instance };
